import { type C4Settings, c4SettingsSchema, DEFAULT_C4_SETTINGS } from '@xox/shared'
import { SettingsFieldset, type SettingsFormProps } from '../components/TurnSecondsField'
import { persisted } from '../lib/storage'

const storage = persisted('c4-room-settings', c4SettingsSchema, DEFAULT_C4_SETTINGS)

export const loadC4Settings = storage.load
export const saveC4Settings = storage.save

export function describeC4Settings(s: C4Settings): string {
  return `${s.turnSeconds} seconds per turn · four in a row wins`
}

/** Connect Four has only the turn clock to set. */
export function C4SettingsForm(props: SettingsFormProps<C4Settings>) {
  return <SettingsFieldset {...props} />
}
